import {ADD_PAYLOAD, DELETE_PAYLOAD, EDIT_PAYLOAD, EDIT_PAYLOAD_FAMILYGROUP, EMPTY_ADD_PAYLOAD, EDIT_PAYLOAD_VOLUMETRICS,} from '../Types/types'

export function storeAddPayload(data: any) {
  return {
    type: ADD_PAYLOAD,
    payload: data
  }
}
export function emptyAddPayload()
{
  return {
    type: EMPTY_ADD_PAYLOAD,
    payload: null
  }
}
export function storeEditPayload(data: any) {
  return {
    type: EDIT_PAYLOAD,
    payload: data
  }
}
export function storeEditPayloadForVolumetrics(data: any) {
  return {
    type: EDIT_PAYLOAD_VOLUMETRICS,
    payload: data
  }
}
export function emptyStoreEditPayload() {
  return {
    type: EDIT_PAYLOAD,
    payload: null
  }
}
export function storeEditPayloadFamilyGroup(data: any) {
  return {
    type: EDIT_PAYLOAD_FAMILYGROUP,
    payload: data
  }
}
export function storeDeletePayload(data: any) {
  return {
    type: DELETE_PAYLOAD,
    payload: data
  }
}